import React, {useEffect} from "react";
import CapServiceTable from "./CapServiceTable";
import CapItemTable from "./CapItemTable";
import Collapse from "reactstrap/es/Collapse";
import {loadFiltersData} from "../../../../actions/filterDataActions";
import {OPERATORS, PARTNER_GROUPS, SUBSCRIPTION_SERVICE_GROUPS} from "../../../../utils/constants";
import {useDispatch} from "react-redux";


export default function  CapContent({isTableSettingsExpanded}) {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(loadFiltersData([SUBSCRIPTION_SERVICE_GROUPS, PARTNER_GROUPS, OPERATORS]));
    }, []);

        return <>
            <Collapse isOpen={isTableSettingsExpanded}>
                <CapServiceTable/>
                <br/>
            </Collapse>
            <CapItemTable/>
        </>
    }